//@flow
import React from 'react'
import './modernizr-custom'

/**
 * Checks if any used features are unavailable.
 * @memberof lib
 */
export function browserIsCompatible() {
  // bail if Modernizr failed to load for any reason
  if (window.Modernizr == null) return true
  const {
    audio,
    cssgrid,
    cssgridlegacy,
    flexbox,
    raf,
    requestanimationframe,
    svg,
    video,
    websockets,
  } = window.Modernizr
  return audio &&
  (cssgrid || cssgridlegacy) &&
  flexbox &&
  raf &&
  requestanimationframe &&
  svg &&
  video &&
  websockets
    ? true
    : false
}

const styles = {
  base: {
    height: '100vh',
    width: '100vw',
    backgroundColor: 'darkGrey',
    paddingTop: 100,
  },
  container: {
    margin: '0 auto',
    width: 360,
    padding: 20,
    paddingBottom: 40,
    backgroundColor: 'white',
  },
  warningHeader: {
    fontSize: '3em',
    color: 'red',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  warning: {
    color: 'red',
  },
  closeButton: {
    float: 'right',
  },
}

/**
 * Renders a large, blocking modal informing a learner they are using an unsupported browser.
 * @memberof components
 */
class UnsupportedBrowerWarning extends React.Component {
  state = {
    display: !browserIsCompatible(),
  }
  close = () => this.setState({ display: false })
  render() {
    if (!this.state.display) {
      return null
    }
    return (
      <div style={styles.base}>
        <div style={styles.container}>
          <h1 style={styles.warningHeader}>WARNING!</h1>
          <p>
            You are about to try and complete this quiz in browser software that
            is not supported.
          </p>
          <p style={styles.warning}>
            This means that the quiz may not work if you proceed.
          </p>
          <p>
            We recommend you use google chrome which you can install by clicking{' '}
            <a
              href="https://www.google.com/chrome/browser"
              target="_blank"
              rel="noopener noreferrer">
              this link.
            </a>
          </p>
          <p>
            <button style={styles.closeButton} onClick={this.close}>
              Click here to continue
            </button>
          </p>
        </div>
      </div>
    )
  }
}

export default UnsupportedBrowerWarning



// WEBPACK FOOTER //
// ./src/lib/check-browser-compatability.js